<template>
    <button @click="menuClick()" v-bind:class="['js-menu-mobile', { active: $store.state.popUpHeaderMenu }]">
        <div class="menu-icon">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    </button>
</template>


<script>
    export default {
        methods: {
            menuClick() {
                this.$store.state.popUpHeaderMenu = !this.$store.state.popUpHeaderMenu;
            }
        }
    }
</script>
